/**
 * Falha ao baixar um chunk lazy — acontece pós-deploy (`s3 sync --delete` apaga
 * os assets antigos) ou offline. Nada quebrou: a aba só está com o index.html velho.
 * As frases mudam por navegador, daí a lista.
 */
const STALE_CHUNK_PATTERNS = [
  'dynamically imported module', // Chrome / Edge
  'error loading dynamically', // Firefox
  'importing a module script failed', // Safari
  'failed to load module script', // Chrome (MIME/404 no chunk)
];

export function isStaleChunkError(error: unknown): boolean {
  const message = (error instanceof Error ? error.message : String(error ?? '')).toLowerCase();
  return STALE_CHUNK_PATTERNS.some((pattern) => message.includes(pattern));
}
